export default __webpack_public_path__ + "static/media/cycle_img.7c1c6f3e.png";